import { FC, ReactNode } from 'react'
import { useSelector } from 'react-redux'
import MainLayout from 'rui/widgets/MainLayout'
import WebviewLayout from 'rui/widgets/WebviewLayout'

const Page: FC<{
  sidebar?: JSX.Element
  background?: JSX.Element
  header?: boolean
  footer?: boolean
  fullscreen?: boolean
  children: ReactNode
}> = (props) => {
  const { sidebar, background, children, header, footer, fullscreen } = props
  const isWebview = useSelector<any, boolean>((state) => state.config.isWebview)

  return isWebview ? (
    <WebviewLayout>{children}</WebviewLayout>
  ) : (
    <MainLayout sidebar={sidebar} background={background} header={header} footer={footer} fullscreen={fullscreen}>
      {children}
    </MainLayout>
  )
}

export default Page
